import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "filter-row border-b border-gray-100 pt-4 pb-2" }
const _hoisted_2 = { class: "flex gap-2 items-center" }
const _hoisted_3 = { class: "font-bold text-sm text-gray-900 tracking-tight" }
const _hoisted_4 = { class: "text-sm text-gray-500 font-light" }
const _hoisted_5 = { class: "text-gray-400 group-hover:text-gray-500 transition-colors" }
const _hoisted_6 = {
  key: 0,
  class: "mt-6 overflow-x-auto no-scrollbar scroll-smooth"
}

import {ref} from 'vue'
import InfoModal from "@/components/info/infoModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'sidebarHeadlineBox',
  props: {
    filterName: {},
    initFilterOpen: { type: Boolean, default: true },
    filterLabel: { default: '' },
    filterValue: { default: '' },
    rawFilterValue: { default: '' },
    rawStoneType: { default: '' },
    showInfo: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;

const isFilterOpen = ref(props.initFilterOpen)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "flex justify-between items-center cursor-pointer group",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isFilterOpen.value = !isFilterOpen.value))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(__props.filterLabel) + ":", 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.filterValue), 1),
        (__props.showInfo && __props.filterName != 'stone_size')
          ? (_openBlock(), _createBlock(InfoModal, {
              key: 0,
              id: __props.filterName,
              value: __props.rawFilterValue,
              "stone-type": __props.rawStoneType
            }, null, 8, ["id", "value", "stone-type"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createElementBlock("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          class: _normalizeClass(["w-4 h-4 transition-transform duration-300", { 'rotate-180': isFilterOpen.value }]),
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor"
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 9l-7 7-7-7"
          }, null, -1)
        ]))], 2))
      ])
    ]),
    (isFilterOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})